import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const hasSubAccess = (u) => !!u && (u.role === 'admin' || u.access_override || ['active', 'trialing'].includes(u.subscription_status));

/* Smart gateway used by newsletter links: mobile → app deeplink, active member → content, otherwise → signup */
export default function GoContent() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    const webFallback = () => {
      if (hasSubAccess(user)) navigate(`/content/${id}`, { replace: true });
      else if (user) navigate('/signup/plans', { replace: true });
      else navigate('/signup', { replace: true });
    };
    const isMobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent);
    if (isMobile) {
      const t = setTimeout(webFallback, 1800);
      window.location.href = `mayaplus://content/${id}`;
      return () => clearTimeout(t);
    }
    webFallback();
  }, [loading, user, id, navigate]);

  return (
    <div className="min-h-screen bg-[#11041F] flex flex-col items-center justify-center gap-4" data-testid="go-content-page">
      <p className="text-3xl font-black text-[#E9641A]">MAYA<span className="text-[#229FA1]">+</span></p>
      <div className="w-8 h-8 border-2 border-[#E9641A] border-t-transparent rounded-full animate-spin" />
      <p className="text-white/50 text-sm">Ouverture du contenu…</p>
    </div>
  );
}
